var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReplay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 16,
    viewBox: "0 0 19 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4237 3.10464H4.07913L4.61383 2.56994C5.08372 2.10005 5.08372 1.32231 4.61383 0.852417C4.14394 0.382528 3.36619 0.382528 2.8963 0.852417L0.352417 3.3963C-0.117472 3.86619 -0.117472 4.64394 0.352417 5.11383L2.8963 7.65771C3.13935 7.90076 3.44721 8.01418 3.75506 8.01418C4.06292 8.01418 4.37078 7.90076 4.61383 7.65771C5.08372 7.18782 5.08372 6.41007 4.61383 5.94018L4.19255 5.5189H12.4237C14.4977 5.5189 16.199 7.20402 16.199 9.29422C16.199 11.3844 14.5139 13.0695 12.4237 13.0695H4.4518C3.78747 13.0695 3.23657 13.6204 3.23657 14.2848C3.23657 14.9491 3.78747 15.5 4.4518 15.5H12.4237C15.8426 15.5 18.6295 12.7131 18.6295 9.29422C18.6295 5.87537 15.8426 3.10464 12.4237 3.10464Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReplay);
export default __webpack_public_path__ + "static/media/replay.9b0ac462830678062839b70cfe1c49c2.svg";
export { ForwardRef as ReactComponent };